import { TicketStatus } from '../enums/ticket-status.enum';
import { OutlookAttachmentDetails } from './outlook-attachment-details.model';
import { ClientField } from '@form-field-module/common/models/client-field.model';
import { FileModelExtended } from '@sb-tools/typescript/models/FileModelExtended.model';

export class NewOutlookTicket {
    allAttachments: OutlookAttachmentDetails[] = [];
    assigneeId = '';
    attachments: FileModelExtended[] = null;
    categoryId?: number = null;
    cc: string[] = [];
    community: string = null;
    content = '';
    fields: ClientField[] = [];
    email = '';
    itemId = '';
    name = '';
    senderInfo = '';
    sourceEmail = '';
    status: TicketStatus = TicketStatus.open;
    subject = '';
}
